export enum DashboardPermissions {
  GET_PENDING_PAYMENTS = 'dashboard.getPendingPayments',
  GET_ACTION_REQUIRED_DRAFT_JOBS = 'dashboard.getActionRequiredDraftJobs',
  GET_ACTION_REQUIRED_PENDING_PROPOSALS = 'dashboard.getActionRequiredPendingProposals',
  GET_ACTION_REQUIRED_PAYMENT_OUTSTANDING_INVOICES = 'dashboard.getActionRequiredPaymentOutstandingInvoices',
}
